/**
 * @generated SignedSource<<b30b7b2e15a122447e3c14133b0bed09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_user$data = {
  readonly tradeFirmDesignManagerProfile?: {
    readonly accountType: string | null;
    readonly hasAccount: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleDesignManager_user" | "PdpRespIconBubbles_user">;
  readonly " $fragmentType": "PdpRespIconBubblesWrapper_user";
};
export type PdpRespIconBubblesWrapper_user$key = {
  readonly " $data"?: PdpRespIconBubblesWrapper_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubblesWrapper_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubblesWrapper_user",
  "selections": [
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmDesignManagerProfileType",
          "kind": "LinkedField",
          "name": "tradeFirmDesignManagerProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasAccount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespIconBubbleDesignManager_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "13983a5559ee00676af0297f90bfba12";

export default node;
